export default __webpack_public_path__ + "static/media/science-bg.7a7d85a9.webp";